import React from 'react'
import { Link } from 'react-router-dom';
import { FaRegMessage } from "react-icons/fa6";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDropleft } from "react-icons/io";
import { BsInfoSquare } from "react-icons/bs";
import { GrDatabase } from "react-icons/gr";
import { RiMobileDownloadFill } from "react-icons/ri";



function ArchiveReportCommon() {
    return (
        <>
            <div className='sm:pt-[70px] pt-[100px] dark:bg-[#121519]  min-h-screen px-4'>
                <div className='bg-[#37715d] w-[100%] flex items-center justify-center rounded-md p-2 shadow-[0px_5px_15px_rgba(0,0,0,0.35)] text-[12px] font-semibold text-[#fff] gap-1 '>
                    <FaRegMessage />

                    <span>   SMS Archive Report</span>
                </div>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 flex items-center gap-2 mt-6 '>
                    <Link to='/Adminhome'>
                    <IoIosArrowDropleft className='text-[36px] dark:text-[#fff]' />
                    </Link>
                    <div>
                        <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>SMS Archive Report</h1>
                        <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward />
                            <span>URL</span><IoIosArrowForward /> <span>Domain URL</span>  </div>
                    </div>
                </div>
                <div className='w-[100%] flex justify-end items-center'>
                    <div className='bg-[rgb(237,237,237)] p-[9px] border-l-[0.25rem] border-black w-full sm:w-[400px]  flex items-center "'>
                        <BsInfoSquare />
                        <span className='text-[12px] ml-2 text-red-600 italic'> Please-note:Reports are available for max.30 days period.</span>
                    </div>
                </div>
                    <div className='w-[100%] flex flex-wrap gap-4'>

                        <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[18%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Start Date</label>
                            <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]' type="Date" />
                        </div>

                        <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[18%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>End Date</label>
                            <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:text-[#fff] dark:bg-[#121519]' type="Date" />
                        </div>
                        <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Search Username</label>
                            <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:text-[#fff] dark:bg-[#121519]'
                            placeholder='Enter UserName'
                            type="text" />
                        </div>

                        

                        <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex items-center gap-1 mt-4'>
                            <button className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'>
                                <GrDatabase />
                                <span className='text-[12px] font-semibold'>Show Data</span>
                            </button>

                            <button className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'>
                                <RiMobileDownloadFill />
                                 <span className='text-[12px] font-semibold '>Download</span>
                            </button>
                        </div>

                    </div>
            </div>
        </>
    )
}

export default ArchiveReportCommon
